export const localStoreKey = {
    user:"user"
}